import React from 'react';
import Icon, { IIconBaseProps } from 'components/icons/Icon';

const GiftBag = (props: IIconBaseProps) => (
  <Icon viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <rect x="16.6562" y="14.0781" width="0.86" height="0.86" fill="currentColor" />
    <rect x="14.0781" y="14.0781" width="0.86" height="0.86" fill="currentColor" />
    <path
      d="M19.9922 10.7109V16.2969C19.9922 16.7717 19.6076 17.1562 19.1328 17.1562H2.28906C1.81426 17.1562 1.42969 16.7717 1.42969 16.2969V5.55469C1.42969 4.84269 2.00676 4.26562 2.71875 4.26562H18.7031C19.4151 4.26562 19.9922 4.84269 19.9922 5.55469V10.7109Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path d="M8.13281 4.26562V17.1562" stroke="currentColor" strokeMiterlimit="10" strokeLinejoin="round" />
    <path d="M1.42969 10.7109H19.9922" stroke="currentColor" strokeMiterlimit="10" strokeLinejoin="round" />
    <path
      d="M8.13281 10.7109L5.02488 9.30844C4.57715 9.10648 4.26562 8.65574 4.26562 8.13281C4.26562 7.42082 4.8427 6.84375 5.55469 6.84375C6.07762 6.84375 6.52836 7.15527 6.73031 7.60301L8.13281 10.7109Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M8.13281 10.7109L11.2407 9.30844C11.6885 9.10648 12 8.65574 12 8.13281C12 7.42082 11.4229 6.84375 10.7109 6.84375C10.188 6.84375 9.73727 7.15527 9.53531 7.60301L8.13281 10.7109Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path d="M5.55469 13.2891C6.97867 13.2891 8.13281 12.1349 8.13281 10.7109" stroke="currentColor" strokeMiterlimit="10" strokeLinejoin="round" />
    <path d="M10.7109 13.2891C9.28695 13.2891 8.13281 12.1349 8.13281 10.7109" stroke="currentColor" strokeMiterlimit="10" strokeLinejoin="round" />
    <rect x="12.7891" y="19.2344" width="0.86" height="0.86" fill="currentColor" />
    <path
      d="M19.9922 6.84375H21.2813C21.9933 6.84375 22.5704 7.42082 22.5704 8.13281V18.875C22.5704 19.3498 22.1858 19.7344 21.711 19.7344H15.2227"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M11.3554 19.7344H4.86719C4.39238 19.7344 4.00781 19.3498 4.00781 18.875V17.1562"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </Icon>
);

export default GiftBag;
